import { Outlet, Navigate } from "react-router-dom";

const Protected = () => {
  const auth = localStorage.getItem("token");
  const isAdmin = localStorage.getItem("isAdmin") === "Admin";
  return auth && isAdmin ? <Navigate to="/events" /> : <Outlet />;
};

export default Protected;
